import { FilterType, ProductsSearchInput } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { FilterBar } from '../../shared/components/filter/filterBar';

export const ProductsFilters = () => {
  return (
    <View style={styles.filtersContainer}>
      <View style={styles.searchContainer}>
        <ProductsSearchInput />
      </View>
      <FilterBar filterButtonTypes={[FilterType.PRODUCTCOLUMNS]} />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  searchContainer: {
    width: 390,
    marginRight: 20,
  },
});
